// add your site specific javascript here
$( document ).ready(function() {
	'use strict';
	/*CATEGORY SCROLL BACK*/
	if($('.page_category').length != 0){
		if(zgReadCookie('last_category') && zgReadCookie('last_category') == location.href){
			$( document ).on( 'zg.getProductInfo.complete',function(){
				if(zgReadCookie('scroll_category')){
					$('body').css('min-height', zgReadCookie('scroll_category')+"px");
					//$(window).scrollTop(zgReadCookie('scroll_category'));
					//$('html, body').animate({ scrollTop: zgReadCookie('scroll_category')+"px" }, {duration: 1200},'linear');
					setTimeout(function(){ 					
						$(window).scrollTop(zgReadCookie('scroll_category'));
						//$('html, body').animate({ scrollTop: zgReadCookie('scroll_category')+"px" }, {duration: 600});
						zgEraseCookie('scroll_category');
					}, 700);
				}
			});
			$(window).scroll(function () {
				zgCreateCookie('scroll_in_category',$(window).scrollTop(),1);			
			});
		}
		zgCreateCookie('last_category',location.href,1);	
	}else{
		if(zgReadCookie('scroll_in_category')){
			zgCreateCookie('scroll_category',zgReadCookie('scroll_in_category'),1);	
			zgEraseCookie('scroll_in_category');
		}else{
			zgEraseCookie('scroll_category');
		}
	}

	
	/*B2B to be approved modal*/
	if($('#b2b_popup_modal').length != 0){
		$("#b2b_popup_modal").modal('show');
	}
	/**/
	

	/*END CATEGORY SCROLL BACK*/
	/*B2B LOGIN*/
	if($('.submit_b2b').length != 0){
		function togglePassword(id) {
			var x = document.getElementById(id);
			if (x.type === "password") {
				x.type = "text";
			} else {
				x.type = "password";
			}
		}
		$('.togglePass').click(function(){
			togglePassword('user_pwd');
			if($(this).find('.fa-eye').length!=0){
				$(this).find('.fa-eye').removeClass('fa-eye').addClass('fa-eye-slash');			
			}else{
				$(this).find('.fa-eye-slash').removeClass('fa-eye-slash').addClass('fa-eye')
			}
		});
		$('.togglePassConfirm').click(function(){
			togglePassword('user_pwd_confirm');
			if($(this).find('.fa-eye').length!=0){
				$(this).find('.fa-eye').removeClass('fa-eye').addClass('fa-eye-slash');			
			}else{
				$(this).find('.fa-eye-slash').removeClass('fa-eye-slash').addClass('fa-eye')
			}
		});
		var $regexname = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,15}$/;
    $('#user_pwd').on('keypress keydown keyup',function(){
				if (!$(this).val().match($regexname)) {
					// there is a mismatch, hence show the error message
						$('.emsg').removeClass('d-none');
						$('.emsg').show();
				}
			else{
						// else, do not display message
						$('.emsg').addClass('d-none');
					}
         });

		/*if( '0' != $('[data-b2b-user-id]').attr('data-b2b-user-id')){
			if(zgReadCookie('b2b-user-id') !=  null){
				zgEraseCookie('b2b-user-id');
				location.href="/";
			}
		}else{
			zgCreateCookie('b2b-user-id','0',1);
		}*/
		if($('[data-b2b-user-id]').length != 0){
			zgCreateCookie('b2b_user_id','0',1);
		}else{
			zgEraseCookie('b2b_user_id');
		}
		$('#shipping_address_country_id').on('change',function(){
			if($('#shipping_address_country_id').val() == '106'){
				$('#fiscal_code').parent('div').removeClass('d-none');
			}else{
				$('#fiscal_code').parent('div').addClass('d-none');
			}
		});
		$('.submit_b2b').click(function(){
			if($('#shipping_address_country_id').val() == '106'){
				if($('#shipping_address_p_iva').val() != "" ){				
					$('#fiscal_code').prop('required',false);
					$('#fiscal_code').removeAttr('required');
				}else{
					$('#fiscal_code').prop("required", true);
					$('#fiscal_code').attr("required", "true");
				}
				if($('#fiscal_code').val() != "" ){				
					$('#shipping_address_p_iva').prop('required',false);
					$('#shipping_address_p_iva').removeAttr('required');
				}else{
					$('#shipping_address_p_iva').prop("required", true);
					$('#shipping_address_p_iva').attr("required", "true");
				}
			}else{
				$('#shipping_address_p_iva').prop("required", true);
				$('#fiscal_code').prop('required',false);
				$('#fiscal_code').removeAttr('required');
				$('#shipping_address_p_iva').attr("required", "true");
			}
			$(this).parents('form').find('[type="submit"]').trigger('click');
		});
	}
	/*END B2B LOGIN*/

	$.ajaxSetup( {
		cache: true
	} );

	//For crawler
	if ( !window.JS_ENABLED ) {
		$.ajax( {
			url:      window.makeUrl( { module: 'eshop', action: 'setJavascriptEnabled' } ),
			type:     'post',
			dataType: 'json'
		} );
	}
	
	// Product page for desktop scroll
	if ($ ('body.page_product > div').length > 1 ) {
		
		$( window ).scroll( function() {
	
			var heightCnt = ( $( '.main-image-wrapper' ).height() - $( '.product-information' ).height() );
			if ( $( this ).scrollTop()  < 200 ){
				$('.product-information').removeClass('is-scrolled');
				$('.swiper-container-vertical').removeClass('is-scrolled');
				$('.product-information').removeClass('scroll-stopped');
				$('.swiper-container-vertical').removeClass('scroll-stopped');
			}else if ( $( this ).scrollTop()  > 200 && $( this ).scrollTop() < heightCnt ){        // If the page is scrolled more than the main-image-wrapper
				$('.product-information').addClass('is-scrolled');
				$('.swiper-container-vertical').addClass('is-scrolled');
				$('.product-information').removeClass('scroll-stopped');
				$('.swiper-container-vertical').removeClass('scroll-stopped');
			} else if ( $( this ).scrollTop() > heightCnt) {
				$('.product-information').removeClass('is-scrolled');
				$('.swiper-container-vertical').removeClass('is-scrolled');
				$('.product-information').addClass('scroll-stopped');
				$('.swiper-container-vertical').addClass('scroll-stopped');
			}
		});
	}
	

	//Return to top
	$( window ).scroll( function() {
		if ( $( this ).scrollTop() > 200) {        // If the page is scrolled more than 200px
			$( '#return-to-top' ).fadeIn( 200 );
		} else {
			$( '#return-to-top' ).fadeOut( 200 );
		}
	});
	$( '#return-to-top' ).click( function() {
		console.log("clicked button!");
		$( 'body,html' ).animate({
			scrollTop : 0
		}, 500);
	});

	var $searchContainer = $( '#searchContainer' );
	$( '[data-zg-role="btn-search"]' ).click( function(){
		if( $searchContainer.hasClass( 'd-none' ) ){
			$searchContainer.removeClass( 'd-none' );
		}
		else {
			$searchContainer.addClass( 'd-none' );
		}
	});
	
	 


	//Increasing-decreasing qty input
	$( '[data-zg-role="change-qty"]' ).click( function(){
		event.preventDefault();
		var type = $( this ).data( 'type' );
		var $inputQtySibling = $( this ).parent().siblings( '[data-zg-role="quantity"]' );
		var maxQty = $inputQtySibling.data( 'max' );
		var floatQty = $inputQtySibling.data( 'floatQty' );
		var qty = $inputQtySibling.val();
		var step;

		if( floatQty ){
			step = 0.01;
		}
		else {
			step = 1;
		}
		qty = Number(qty);

		$( '[data-zg-role="change-qty"]' ).attr( 'disabled', false );
		if( type == "minus" ){
			//If qty is 0, we will disable the current minus icon.
			//The next time this function will be run, all the change qty icons will be enabled again.
			if( qty == 0 ){
				$( this ).attr( 'disabled', true );
			}
			else{
				qty = qty - step;
			}
		}
		else {
			//If qty is equal to maxQty, we will disable the current plus icon.
			//The next time this function will be run, all the change qty icons will be enabled again.
			if( qty == maxQty ){
				$( this ).attr( 'disabled', true );
			}
			else {
				qty = qty + step;
			}
		}

		$( this ).parent().siblings( '[data-zg-role="quantity"]' ).val( qty );
	});
	
	/* Toggle class active in bootstrap collapse */
	$('[data-toggle="collapse"]').click(function() {
  	$(this).toggleClass( "active" );
	});
	
	
	/* active tabs for Cart checkout login*/
	
	$(".login-checkout-tab li").click(function() {
		$(".login-checkout-tab li").removeClass('active');
		$(this).addClass('active');    
	});
	
	/*(custom checkbox radio */
	
	$('.nav-item-checkout a').click(function() {
			$(".input-payment").prop('checked', false);
			$(".input-payment",this).prop('checked', true);
  	});
	
	$('#0-tab').click(function() {
			$(".input-payment").prop('checked', false);
			$("#paymentRadios0").prop('checked', true);
  	});
	
	
	$(document).ready(function(){
	$(document).on('click','[data-zg-role="share-this"]',function(e){
		e.preventDefault();				
		$('.breadcrumbs__share-list').toggleClass('active');
		$(this).toggleClass('share-this-active');
	});
	
	$(document).on('click','[data-zg-role="mobile-phone"]',function(e){
		e.preventDefault();				
		$('.mobile-phone').toggleClass('active');
		$(this).toggleClass('mobile-phone-active');
	});
	
});	
	
	
			//social modal copy-link button
		$('.copy-link').on('click', function() {
			$(this).siblings('input.linkToCopy').select();      
			//document.execCommand("copy");		
			try {
				var successful = document.execCommand('copy');
				var msg = successful ? '       copied' : 'try again';			
				$('.copy-msg').html(msg).fadeIn(200);
				setTimeout(function() {
					$('.copy-msg').fadeOut(200);
				}, 1000);			
			} catch (err) {
				console.log('Something is wrong. Try again');
			}		
		});


	
	
	/* close info landing */
	if (document.getElementsByClassName("landing-componentImagesAndDescriptions") != null ){
		closeModal();
	}
	
	function closeModal(){
		Array.from(document.getElementsByClassName("closebtn")).forEach(
					function(element, index, array) {
								element.addEventListener("click", listener.bind(null, index));													
					function listener(i){
								document.getElementById(`modal_${i}`).classList.add("d-none");
		}});

		Array.from(document.getElementsByClassName("info_button")).forEach(
					function(element, index, array) {
								element.addEventListener("click", listener.bind(null, index));													
					function listener(i){
								document.getElementById(`modal_${i}`).classList.remove("d-none");
		}});
	}
	
	if (document.getElementsByClassName("slider_shopTheStory") != null ){
		closeModal_shopTheStory();
	}
	
	function closeModal_shopTheStory(){
		Array.from(document.getElementsByClassName("closebtn_shopTheStory")).forEach(
					function(element, index, array) {
								element.addEventListener("click", listener.bind(null, index));													
					function listener(i){
								document.getElementById(`modal_shopTheStory_${i}`).classList.add("d-none");
		}});

		Array.from(document.getElementsByClassName("info-center")).forEach(
					function(element, index, array) {
								element.addEventListener("click", listener.bind(null, index));													
					function listener(i){
								document.getElementById(`modal_shopTheStory_${i}`).classList.remove("d-none");
		}});
	}

	if (document.getElementsByClassName("lookbook") != null ){
		closeModal_lookbook();
	}
	
	function closeModal_lookbook(){
		Array.from(document.getElementsByClassName("closebtn-lookbook")).forEach(
					function(element, index, array) {
								element.addEventListener("click", listener.bind(null, index));													
					function listener(i){
									document.querySelector(`[data-modal="modal_lookbook_${i}"]`).classList.add("d-none");
		}});

		Array.from(document.getElementsByClassName("info_button-lookbook")).forEach(
					function(element, index, array) {
						element.addEventListener("click", listener.bind(null, index));													
					function listener(i){
								document.querySelector(`[data-modal="modal_lookbook_${i}"]`).classList.remove("d-none");
		}});
				Array.from(document.getElementsByClassName("closebtn-lookbook-mobile")).forEach(
					function(element, index, array) {
								element.addEventListener("click", listener.bind(null, index));													
					function listener(i){
									Array.from(document.querySelectorAll(`[data-modal="modal_lookbook_${i}"]`)).forEach(element => element.classList.add("d-none"));
		}});

		Array.from(document.getElementsByClassName("info_button-lookbook-mobile")).forEach(
					function(element, index, array) {
						element.addEventListener("click", listener.bind(null, index));													
					function listener(i){
								Array.from(document.querySelectorAll(`[data-modal="modal_lookbook_${i}"]`)).forEach(element => element.classList.remove("d-none"));
		}});
	}

	
	
	/* CATEGORY PAGE SORT BY DROPDOWN */


	$('.dropdown .dropdown-item').on('click', function(){
    $('#show').text($(this).text());
	});
	$(document).ready(function() {
		$('#show').text($(".dropdown .dropdown-item[id='default-option']").text());
	});
	
				

	/* CATEGORY PAGE FILTER COLLAPSE */
	$('.btn-filter').on('show.bs.collapse', function() {
		$('#filter-wrapper').addClass( 'show' );
	});
	$('.btn-filter').on('hide.bs.collapse', function () {
		$('#filter-wrapper').removeClass( 'show' );
	});

	$('.btn-resize').click(function(){
		$('.category-list').toggleClass( 'resizeCat' );
		$('#filter-wrapper').css( 'top:22px' );
			if ($('.close-text').hasClass('d-none')){
				$('.close-text').removeClass('d-none')
			}else{
				$('.close-text').addClass('d-none')
			}
	});

	
	/* CATEGORY PAGE FILTER MOBILE */
	/*data-zg-role="openFilterMobile" data-open="filter-container"*/
	
	$(document).on('click','[data-zg-role="openFilterMobile"]',function(e){
		e.preventDefault();
		e.stopPropagation();
		var $this = $( this );
		var id = $( this ).data('open');
		
		if ( $this.hasClass('is-open') ){
			//$('body').addClass( 'stop-scrolling' );
			$(`.btn[data-open=${id}]`).removeClass('is-open');
			closeNav( id );
		}else{
			//$('body').removeClass( 'stop-scrolling' );
			$(`.btn[data-open=${id}]`).addClass('is-open');
			openNav( id );
		}
		
		$( this ).toggleClass('is-open')
		
	});
	
	/* HEADER */
	/* dropdown menu in main header menu open with hover event
	$('#site_header ul.navbar-nav li.dropdown').hover(function() {
		$(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(300);
	}, function() {
		$(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(300);
	});*/
	
	/* dropdown main menu header for desktop version*/
	$('#navbarNav').on('show.bs.dropdown', function () {
		statusOpen();
	});
	$('#navbarNav').on('hide.bs.dropdown', function () {
		statusClose();
	});
	/**/
	
	/* main menu header for mobile version*/
	
	
	/* open/close version navbar menu mobile */
	$(document).on('click','[data-zg-role="openNavbarMobile"]',function(e){
		e.preventDefault();
		e.stopPropagation();
		var $this = $( this );
		var id = $( this ).data('open');
		
		statusClose();
		
		if ( $this.hasClass('is-open') ){
			$(`.navbar-toggler[data-open=${id}]`).removeClass('is-open');
			closeNav( id );
		}else{
			$(`.navbar-toggler[data-open=${id}]`).addClass('is-open');
			statusOpen();
			openNav( id );
		}
	});
	
	/* open/close version nav item II level */
	$(document).on('click','[data-zg-role="openNavItemIIlvl"]',function(e){
		e.preventDefault();
		e.stopPropagation();
		var $this = $( this );
		var id = $( this ).data('open');
		
		if ( $this.hasClass('is-open') ){
			$('#site_header').removeClass( 'menuIIlvlOpen' );
			$(`.navitem-toggler[data-open=${id}]`).removeClass('is-open');
			$(`.nav-link[data-open=${id}]`).removeClass('is-open');
			closeNav( id );
		}else{
			$('#site_header').addClass( 'menuIIlvlOpen' );
			$(`.navitem-toggler[data-open=${id}]`).addClass('is-open');
			$(`.nav-link[data-open=${id}]`).addClass('is-open');
			openNav( id );
		}													
	});
	
	/* Set the width of the side navigation to 0 */
	function closeNav(id) {
		document.getElementById(id).style.left = "-100%";
	}
	
	/* Set the width of the side navigation to 100% */
	function openNav(id) {
		document.getElementById(id).style.left = "0";
	}
	
	/* collapse main menu */
	$('#navbarNav.navbar-collapse').on('show.bs.collapse', function() {
		$('#navbarSearch .dropdown-menu').removeClass('show');
		$('#navbarCart .dropdown-menu').removeClass('show');
		setTimeout(function() { 
			statusOpen();
    }, 50);
	});
	$('#navbarNav.navbar-collapse').on('hide.bs.collapse', function () {
		statusClose();
	});
	/**/
	
	/* manage open/close nav tool for mobile version*/
	$('#navbarCart').on('show.bs.dropdown', function () {
		$('body').addClass( 'stop-scrolling' );
		$('#site_header').addClass( 'cartOpen' );
	});
											
	$('#navbarCart').on('hide.bs.dropdown', function () {
		$('body').removeClass( 'stop-scrolling' );
		$('#site_header').removeClass( 'cartOpen' );
	});
	
	$('#navbarSearch').on('show.bs.dropdown', function () {
		$('#navbarNav.navbar-collapse').removeClass('show');
		statusOpen();
		$('#site_header').addClass( 'searchOpen' );
	});
	
	$('#navbarSearch').on('hide.bs.dropdown', function () {
		statusClose();
		$('#site_header').removeClass( 'searchOpen' );
	});
	
	function statusOpen (){
		$('body').addClass( 'stop-scrolling' );
		$('#site_header').addClass( 'menuOpen' );
	}
	
	function statusClose (){
		$('body').removeClass( 'stop-scrolling' );
		$('#navbarSearch .dropdown-menu').removeClass('show');
		$('#navbarCart .dropdown-menu').removeClass('show');
		$('#site_header').removeClass( 'menuOpen' );
		$('#site_header').removeClass( 'searchOpen' );
		$('#site_header').removeClass( 'cartOpen' );
	}
	
/**/
	
});



$( document ).ready(function() {
		if ($('.homePageProduct').length != 0 ){ 
 //	if (document.getElementsByClassName("homePageProduct") != null ){

		homePageProductSlider();
	}

		function homePageProductSlider(){
			var slider = tns({
			"container": ".slider_homePageProduct",
			"nav": false,
			"items": 1,
			"controls": true,
			"rewind": true,
			"controlsPosition": "bottom",
			"mode": "carousel",
			"swipeAngle": false,
			"speed": 400, 
			"controlsText": [" "," "],
			"loop": false,
			"responsive": {
				"992": {
			"items": 4,
			"controlsPosition": "bottom",
			"swipeAngle": false,
			"speed": 400,
			"gutter": 7, 
			"controlsText": [" "," "],
			"loop": false			
				}}
		});
		//document.querySelector('.control-next').onclick = function () { slider.goTo('next'); };
		//document.querySelector('.control-prev').onclick = function () { slider.goTo('prev'); };
		}
if ($('.shopTheStory').length != 0 ){ 
	// if (document.getElementsByClassName("shopTheStory").lenght != 0 ){
		shopTheStorySlider();
	}
			function shopTheStorySlider(){
			var slider = tns({	
				"container": ".slider_shopTheStory",
				"nav": false,
				"items": 1,
				"controlsPosition": "bottom",
				"mode": "gallery",
				"loop": false,
				"swipeAngle": false,
				"speed": 400,
				"controlsText": [" "," "]
			});
}

		if ($('.ourBrands').length != 0 ){ 
	
		ourBrandsSlider();
	}
			function ourBrandsSlider(){
				var slider = tns({	
				"container": ".slider_ourBrands",
				"nav": false,
				"items": 1,
				"center": true,
				"edgePadding": 0,
				"loop" : true,
				"gutter": 0,
				"controlsPosition": "bottom",
				"mode": "carousel",
				"swipeAngle": false,
				"speed": 400,
				"controlsText": [" "," "],
				"responsive": {
				"992": {
					"edgePadding": 50,	
				"items": 2,
				"gutter": 0	
				}}
			});
			}

	if ($('.lookbook').length != 0 ){ 
	
		lookbookSlider();
	}
			function lookbookSlider(){
				var slider = tns({	
				"container": ".slider_lookbook",
				"nav": false,
				"items": 1,
				"center": true,
				"edgePadding": 0,
				"gutter": 0,
				"controlsPosition": "bottom",
				"mode": "carousel",
				"swipeAngle": false,
				"speed": 400,
				"controlsText": [" "," "],
			});
			}



});

if ($('.videoHp').length != 0 ){ 

	const player = new Plyr('#playerHp');
}

$( document ).ready(function() {
	'use strict';

	//HOVER MAIN MENU
	$('#site_header #navbarNav .nav-item').hover(function() {

		var timerOpen;
		var timerClosed;
		var $this = $(this);
		//if( getParameterByName('debug')==1 && $(this).find('.dropdown + .dropdown-menu').length != 0 ){
		if( $(this).find('.dropdown-toggle + .dropdown-menu').length != 0 ){
		if(!$(this).hasClass('show')){
			timerOpen=setTimeout(function(){
				clearTimeout(timerClosed);
				$this.find('.dropdown-menu').stop(true).fadeIn(400);
				$this.toggleClass('show');
			},0);
		}else{  	
			timerClosed=setTimeout(function(){
				clearTimeout(timerOpen);
				$this.find('.dropdown-menu').stop(true).fadeOut(500);
				$this.toggleClass('show');
			},500);
		}
		}
	});

});


// Gift card

$(document).ready(function() {  
    if( $("#voucher_amount").length){
        
        $('[data-zg-role="voucher_amount_custom"]').hide();
        
        $( document ).on( 'click','[data-zg-role="voucher_amount"]',function(e){
            //e.stopPropagation();
            e.preventDefault();
            var value = $(this).data('value');
            
            if (value == 'amount'){
                $('[data-zg-role="voucher_amount_custom"]').show();
                $('#voucher_amount').val('');
            }else{
                $('#voucher_amount').val(value);
                $('[data-zg-role="voucher_amount_custom"]').hide();
            }
            
            $('[data-zg-role="voucher_amount"]').removeClass('active');
            $(this).addClass('active');
            

        }); 
    }


    if( $('[data-zg-role="gift_card_type"]').length){
        $( document ).on( 'click','[data-zg-role="gift_card_type"]',function(e){
            e.preventDefault();
            $('[data-zg-role="gift_card_type"]').removeClass('active');
            $(this).addClass('active');
            var value = $(this).data('value');
            $('#voucher_custom_fields_gift_card_type').val(value);
            $('#voucher_custom_fields_gift_card_type').valid();
        });
    }
}); 


/* CLOSE MODAL AFTER ADD TO CART */

if ( $('.page_category').length ){
	$(document).on('zg.product.addedToCart',function(){
		var quickbuy = ($('#quickbuy').data('bs.modal') || {})._isShown
		
		if($('#quickbuy').length && quickbuy == true){
			console.log("open modal")
			$('#quickbuy').modal('hide');
		}		
	});
}
